import { useState, useEffect } from 'react'
import { SidebarLayoutNew } from '../components/sidebar-layout-new'
import { BreadcrumbsNew } from '../components/breadcrumbs'
import { Heading } from '../components/heading'
import { Fragment } from 'react/jsx-runtime'
import { Badge } from '../components/badge'
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react'
import { MinusIcon, PlusIcon } from '@heroicons/react/24/outline'
import { DocumentPlusIcon } from '@heroicons/react/16/solid';
import { PageInfo } from '../components/page-info'
import { Button } from '../components/button'
import { useAlert } from "../components/customAlert"
import { Checkbox, CheckboxField, CheckboxGroup } from '../components/checkbox'
import { Dialog, DialogActions, DialogBody, DialogDescription, DialogTitle } from '../components/dialog'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/table'
import { EllipsisVerticalIcon } from '@heroicons/react/20/solid'
const page_info = `Here you can choose company from available GMC accounts to add`;

const pages = [
  { name: "Add New Company", href: "/my-settings", current: true },
];


const projects = [
  { name: 'Graph API', initials: 'GA', href: '#', members: 16, bgColor: 'bg-pink-600 dark:bg-pink-700' },
  { name: 'Component Design', initials: 'CD', href: '#', members: 12, bgColor: 'bg-purple-600 dark:bg-purple-700' },
  { name: 'Templates', initials: 'T', href: '#', members: 16, bgColor: 'bg-yellow-500 dark:bg-yellow-600' },
  { name: 'React Components', initials: 'RC', href: '#', members: 8, bgColor: 'bg-green-500 dark:bg-green-600' },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}
export default function MySettings() {
  const { showAlert } = useAlert();
  const [selectedIds, setSelectedIds] = useState([]);
  let [isOpenConfirm, setIsOpenConfirm] = useState(false);
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [confirmed, setConfirmed] = useState(false);//for confirmation
  const [page, setPage] = useState(1);
  useEffect(() => {
  	if (confirmed) {
		  setConfirmed(false); // reset flag
		  showAlert('Add company process initiated. Once completed, we will notify via email', "" , "success",3000);
		  //console.log("added companies:", selectedIds);	
		  setSelectedIds([]);		    
		 // fetchProducts(page);
		}
	}, [confirmed, page, selectedIds]);

  // Handle checkbox toggle
  const handleCheckboxChange = (id) => {
	//console.log(id);
	if (!id) return; // prevent pushing undefined	
    setSelectedIds((prev) => {
		  const newSelected = prev.includes(id)
			? prev.filter((item) => item !== id) // unselect
			: [...prev, id]; // select	  
		  return newSelected;
		});	
  };
  const handleAddCompany = async () => {
    if (selectedIds.length === 0) {
		//setPopupHeading('⚠️ Alert');
		//setPopupMessage('Please select at least one account to proceed.');		
		//setIsOpen(true);

		 showAlert('Please select at least one account to proceed.', "Error" , "error",3000);
		
		//setErrorMsg('Please select at least one account to proceed.');
		//setShowErrorBox(true);
		//setTimeout(() => {
			//setShowErrorBox(false);
			//setErrorMsg("");
		//}, 3000);
		
		return;    	  	
  	}	
	// Show confirmation popup  	
	setIsOpenConfirm(true);   	
  };
  return (
    <Fragment>
      <SidebarLayoutNew selected_menu="my-settings">
        <BreadcrumbsNew pages={pages} />
          <div className='hidden sm:block'>
            <div className="flex w-full items-center gap-3 !pl-0 rounded-lg px-2 py-2.5 text-left text-base/4 font-medium text-zinc-950 sm:py-2 sm:text-sm/4 *:data-[slot=icon]:size-6 *:data-[slot=icon]:shrink-0 *:data-[slot=icon]:fill-zinc-500 sm:*:data-[slot=icon]:size-5 *:last:data-[slot=icon]:ml-auto *:last:data-[slot=icon]:size-5 sm:*:last:data-[slot=icon]:size-4 *:data-[slot=avatar]:-m-0.5 *:data-[slot=avatar]:size-7 sm:*:data-[slot=avatar]:size-6 data-hover:bg-zinc-950/5 data-hover:*:data-[slot=icon]:fill-zinc-950 data-active:bg-zinc-950/5 data-active:*:data-[slot=icon]:fill-zinc-950 data-current:*:data-[slot=icon]:fill-zinc-950 dark:text-white dark:*:data-[slot=icon]:fill-zinc-400 dark:data-hover:bg-white/5 dark:data-hover:*:data-[slot=icon]:fill-white dark:data-active:bg-white/5 dark:data-active:*:data-[slot=icon]:fill-white dark:data-current:*:data-[slot=icon]:fill-white">
              <DocumentPlusIcon className="!size-8"/>
              <Heading>Link From GMC</Heading>
            </div>
          </div>
          <PageInfo info={page_info} />

          <div>
            <ul role="list" className="mt-3 grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6 lg:grid-cols-1">
              <li key="1" className="col-span-1 flex rounded-md shadow-md dark:shadow-none bg-stone-600 dark:bg-gray-900">
                <div class="w-1/5 text-white rounded-l-md m-auto">
                  <div className={classNames("",'text-center rounded-l-md text-sm/6 font-medium m-4',)} >
                    <p>DryRobe</p>
                    <p>(157509301)</p>
                  </div>
                </div>
                <div className="flex flex-1 items-center justify-between truncate bg-white dark:bg-gray-800/50">
                  <div className="flex-1 truncate text-sm/6">
                    <ul role="list" className="grid grid-cols-1 gap-2 sm:grid-cols-2 sm:gap-2 lg:grid-cols-1">
                      <li key="1" className="col-span-1 flex dark:shadow-none bg-stone-200 dark:bg-gray-900 ">
                        <div class="w-1/4 m-auto">
                          <div className={classNames("",'flex items-center justify-center rounded-l-md text-sm/6 font-medium m-4',)} >
                            DryRobe DE (582880505)
                          </div>
                        </div>
                        <div className="flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b border-gray-200 bg-white dark:border-white/10 dark:bg-gray-800/50 w-full">
                          <div className="flex truncate px-4 py-2 text-sm/6 w-full">
                            <div className='w-1/5'>
                              <div class="text-gray-500 text-sm font-semibold">Feed ID</div>
                              <div class="text-sm text-gray-900 dark:text-gray-100">12345678</div>
                            </div>
                            <div className='w-2/5'>
                              <div class="text-gray-500 text-sm font-semibold">Feed Name</div>
                              <div class="text-sm text-gray-900 dark:text-gray-100">DryRobe DE | FeedSpark</div>
                            </div>
                            <div  className='w-1/5'>
                              <div class="text-gray-500 text-sm font-semibold">Country</div>
                              <div class="text-sm text-gray-900 dark:text-gray-100">DE</div>
                            </div>
                            <div className='w-1/5'>
                              <span className="ml-6 flex h-7 items-center float-right">
                                <CheckboxGroup>
                                  <CheckboxField>
                                    <Checkbox name="discoverability" value="show_on_events_page" checked={selectedIds.includes("dryrobe_de")} onChange={() => handleCheckboxChange("dryrobe_de")} />
                                  </CheckboxField>
                                </CheckboxGroup>
                              </span>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li key="1" className="col-span-1 flex dark:shadow-none bg-stone-200 dark:bg-gray-900">
                        <div class="w-1/4 m-auto">
                          <div className={classNames("",'flex items-center justify-center rounded-l-md text-sm/6 font-medium m-4',)} >
                            DryRobe FR (5380686624)
                          </div>
                        </div>
                        <div className="flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b border-gray-200 bg-white dark:border-white/10 dark:bg-gray-800/50 w-full">
                          <div className="flex truncate px-4 py-2 text-sm/6 w-full">
                            <div className='w-1/5'>
                              <div class="text-gray-500 text-sm font-semibold">Feed ID</div>
                              <div class="text-sm text-gray-900 dark:text-gray-100">7654380</div>
                            </div>
                            <div className='w-2/5'>
                              <div class="text-gray-500 text-sm font-semibold">Feed Name</div>
                              <div class="text-sm text-gray-900 dark:text-gray-100">DryRobe FR | FeedSpark</div>
                            </div>
                            <div  className='w-1/5'>
                              <div class="text-gray-500 text-sm font-semibold">Country</div>
                              <div class="text-sm text-gray-900 dark:text-gray-100">FR</div>
                            </div>
                            <div className='w-1/5'>
                              <span className="ml-6 flex h-7 items-center float-right">
                                <CheckboxGroup>
                                  <CheckboxField>
                                    <Checkbox name="discoverability" value="show_on_events_page" checked={selectedIds.includes("dryrobe_fr")} onChange={() => handleCheckboxChange("dryrobe_fr")} />
                                  </CheckboxField>
                                </CheckboxGroup>
                              </span>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>

              <li key="2" className="col-span-1 flex rounded-md shadow-md dark:shadow-none bg-stone-600 dark:bg-gray-900">
                <div class="w-1/5 text-white rounded-l-md m-auto">
                  <div className={classNames("",'text-center rounded-l-md text-sm/6 font-medium m-4',)} >
                    <p>Wickes</p>
                    <p>(762739295)</p>
                  </div>
                </div>
                <div className="flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b border-gray-200 bg-white dark:border-white/10 dark:bg-gray-800/50 w-full">
                  <div className="flex truncate px-4 py-2 text-sm/6 w-full">
                    <div className='w-1/5'>
                      <div class="text-gray-500 text-sm font-semibold">Feed ID</div>
                      <div class="text-sm text-gray-900 dark:text-gray-100">222444333</div>
                    </div>
                    <div className='w-2/5'>
                      <div class="text-gray-500 text-sm font-semibold">Feed Name</div>
                      <div class="text-sm text-gray-900 dark:text-gray-100">Wickes Primary | FeedSpark</div>
                    </div>
                    <div  className='w-1/5'>
                      <div class="text-gray-500 text-sm font-semibold">Country</div>
                      <div class="text-sm text-gray-900 dark:text-gray-100">GB</div>
                    </div>
                    <div className='w-1/5'>
                      <span className="ml-6 flex h-7 items-center float-right">
                        <CheckboxGroup>
                          <CheckboxField>
                            <Checkbox name="discoverability" value="show_on_events_page" checked={selectedIds.includes("wickes")} onChange={() => handleCheckboxChange("wickes")} />
                          </CheckboxField>
                        </CheckboxGroup>
                      </span>
                    </div>
                  </div>
                </div>
              </li>


              <li key="3" className="col-span-1 flex rounded-md shadow-md dark:shadow-none bg-stone-600 dark:bg-gray-900">
                <div class="w-1/5 text-white rounded-l-md m-auto">
                  <div className={classNames("",'text-center rounded-l-md text-sm/6 font-medium m-4',)} >
                    <p>Hobbs</p>
                    <p>(451122185)</p>
                  </div>
                </div>
                <div className="flex flex-1 items-center justify-between truncate  bg-white dark:bg-gray-800/50">
                  <div className="flex-1 truncate text-sm/6">
                    <ul role="list" className="grid grid-cols-1 gap-2 sm:grid-cols-1 sm:gap-2 lg:grid-cols-1">
                      <li key="1" className="col-span-1 flex dark:shadow-none bg-stone-200 dark:bg-gray-900">
                        <div class="w-1/4 m-auto">
                          <div className={classNames("",'flex items-center justify-center rounded-l-md text-sm/6 font-medium m-4',)} >
                            Hobbs (8416022)
                          </div>
                        </div>
                        <div className="flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b border-gray-200 bg-white dark:border-white/10 dark:bg-gray-800/50 w-full">
                          <div className="text-sm/6 w-full">
                            <ul role="list" className="grid grid-cols-1 gap-2 sm:grid-cols-1 sm:gap-2 lg:grid-cols-1">
                              <li key="1" className="col-span-1 flex rounded-md shadow-xs dark:shadow-none">
                                <div className="flex flex-1 items-center justify-between truncate  rounded-r-md border-t border-r border-b border-gray-200 bg-white dark:border-white/10 dark:bg-gray-800/50 w-full">
                                  <div className="flex truncate px-4 py-2 text-sm/6 w-full">
                                    <div className='w-1/5'>
                                      <div class="text-gray-500 text-sm font-semibold">Feed ID</div>
                                      <div class="text-sm text-gray-900 dark:text-gray-100">9876543</div>
                                    </div>
                                    <div className='w-2/5'>
                                      <div class="text-gray-500 text-sm font-semibold">Feed Name</div>
                                      <div class="text-sm text-gray-900 dark:text-gray-100">Hobbs AU Feed</div>
                                    </div>
                                    <div  className='w-1/5'>
                                      <div class="text-gray-500 text-sm font-semibold">Country</div>
                                      <div class="text-sm text-gray-900 dark:text-gray-100">AU</div>
                                    </div>
                                    <div className='w-1/5'>
                                      <span className="ml-6 flex h-7 items-center float-right">
                                        <CheckboxGroup>
                                          <CheckboxField>
                                            <Checkbox name="discoverability" value="show_on_events_page" checked={selectedIds.includes("hobbs_au")} onChange={() => handleCheckboxChange("hobbs_au")} />
                                          </CheckboxField>
                                        </CheckboxGroup>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li key="1" className="col-span-1 flex rounded-md shadow-xs dark:shadow-none">
                                <div className="flex flex-1 items-center justify-between truncate  rounded-r-md border-t border-r border-b border-gray-200 bg-white dark:border-white/10 dark:bg-gray-800/50 w-full">
                                  <div className="flex truncate px-4 py-2 text-sm/6 w-full">
                                    <div className='w-1/5'>
                                      <div class="text-gray-500 text-sm font-semibold">Feed ID</div>
                                      <div class="text-sm text-gray-900 dark:text-gray-100">7654311</div>
                                    </div>
                                    <div className='w-2/5'>
                                      <div class="text-gray-500 text-sm font-semibold">Feed Name</div>
                                      <div class="text-sm text-gray-900 dark:text-gray-100 text-wrap">Hobbs US Feed</div>
                                    </div>
                                    <div  className='w-1/5'>
                                      <div class="text-gray-500 text-sm font-semibold">Country</div>
                                      <div class="text-sm text-gray-900 dark:text-gray-100">US</div>
                                    </div>
                                    <div className='w-1/5'>
                                      <span className="ml-6 flex h-7 items-center float-right">
                                        <CheckboxGroup>
                                          <CheckboxField>
                                            <Checkbox name="discoverability" value="show_on_events_page" checked={selectedIds.includes("hobbs_us")} onChange={() => handleCheckboxChange("hobbs_us")} />
                                          </CheckboxField>
                                        </CheckboxGroup>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li key="1" className="col-span-1 flex rounded-md shadow-xs dark:shadow-none">
                                <div className="flex flex-1 items-center justify-between truncate  rounded-r-md border-t border-r border-b border-gray-200 bg-white dark:border-white/10 dark:bg-gray-800/50 w-full">
                                  <div className="flex truncate px-4 py-2 text-sm/6 w-full">
                                    <div className='w-1/5'>
                                      <div class="text-gray-500 text-sm font-semibold">Feed ID</div>
                                      <div class="text-sm text-gray-900 dark:text-gray-100">5670098</div>
                                    </div>
                                    <div className='w-2/5'>
                                      <div class="text-gray-500 text-sm font-semibold">Feed Name</div>
                                      <div class="text-sm text-gray-900 dark:text-gray-100 text-wrap">Hobbs GB Feed</div>
                                    </div>
                                    <div  className='w-1/5'>
                                      <div class="text-gray-500 text-sm font-semibold">Country</div>
                                      <div class="text-sm text-gray-900 dark:text-gray-100">GB</div>
                                    </div>
                                    <div className='w-1/5'>
                                      <span className="ml-6 flex h-7 items-center float-right">
                                        <CheckboxGroup>
                                          <CheckboxField>
                                            <Checkbox name="discoverability" value="show_on_events_page" checked={selectedIds.includes("hobbs_gb")} onChange={() => handleCheckboxChange("hobbs_gb")} />
                                          </CheckboxField>
                                        </CheckboxGroup>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>

                <li key="4" className="col-span-1 flex rounded-md shadow-md dark:shadow-none bg-stone-600 dark:bg-gray-900">
                <div class="w-1/5 text-white rounded-l-md m-auto">
                  <div className={classNames("",'text-center rounded-l-md text-sm/6 font-medium m-4',)} >
                    <p>Modibodi</p>
                    <p>(136841728)</p>
                  </div>
                </div>
                <div className="flex flex-1 items-center justify-between truncate bg-white dark:bg-gray-800/50">
                  <div className="flex-1 truncate text-sm/6">
                    <ul role="list" className="grid grid-cols-1 gap-2 sm:grid-cols-2 sm:gap-2 lg:grid-cols-1">
                      <li key="1" className="col-span-1 flex dark:shadow-none bg-stone-200 dark:bg-gray-900 ">
                        <div class="w-1/4 m-auto">
                          <div className={classNames("",'flex items-center justify-center rounded-l-md text-sm/6 font-medium m-4',)} >
                            Modibodi EU (67890097)
                          </div>
                        </div>
                        <div className="flex flex-1 items-center justify-between truncate  bg-white dark:bg-gray-800/50">
                          <div className="flex-1 truncate text-sm/6">
                            <ul role="list" className="grid grid-cols-1 gap-2 sm:grid-cols-1 sm:gap-2 lg:grid-cols-1">
                              <li key="1" className="col-span-1 flex dark:shadow-none bg-gray-200 dark:bg-gray-900">
                                <div className="flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b border-gray-200 bg-white dark:border-white/10 dark:bg-gray-800/50 w-full">
                                  <div className="text-sm/6 w-full">
                                    <ul role="list" className="grid grid-cols-1 gap-2 sm:grid-cols-1 sm:gap-2 lg:grid-cols-1">
                                      <li key="1" className="col-span-1 flex rounded-md shadow-xs dark:shadow-none">
                                        <div className="flex flex-1 items-center justify-between truncate  rounded-r-md border-t border-r border-b border-gray-200 bg-white dark:border-white/10 dark:bg-gray-800/50 w-full">
                                          <div className="flex truncate px-4 py-2 text-sm/6 w-full">
                                            <div className='w-1/5'>
                                              <div class="text-gray-500 text-sm font-semibold">Feed ID</div>
                                              <div class="text-sm text-gray-900 dark:text-gray-100">3456809</div>
                                            </div>
                                            <div className='w-2/5'>
                                              <div class="text-gray-500 text-sm font-semibold">Feed Name</div>
                                              <div class="text-sm text-gray-900 dark:text-gray-100">Modibodi EU AT</div>
                                            </div>
                                            <div  className='w-1/5'>
                                              <div class="text-gray-500 text-sm font-semibold">Country</div>
                                              <div class="text-sm text-gray-900 dark:text-gray-100">AT</div>
                                            </div>
                                            <div className='w-1/5'>
                                              <span className="ml-6 flex h-7 items-center float-right">
                                                <CheckboxGroup>
                                                  <CheckboxField>
                                                    <Checkbox name="discoverability" value="show_on_events_page" checked={selectedIds.includes("mb_at")} onChange={() => handleCheckboxChange("mb_at")} />
                                                  </CheckboxField>
                                                </CheckboxGroup>
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </li>
                                      <li key="1" className="col-span-1 flex rounded-md shadow-xs dark:shadow-none">
                                        <div className="flex flex-1 items-center justify-between truncate  rounded-r-md border-t border-r border-b border-gray-200 bg-white dark:border-white/10 dark:bg-gray-800/50 w-full">
                                          <div className="flex truncate px-4 py-2 text-sm/6 w-full">
                                            <div className='w-1/5'>
                                              <div class="text-gray-500 text-sm font-semibold">Feed ID</div>
                                              <div class="text-sm text-gray-900 dark:text-gray-100">6789110</div>
                                            </div>
                                            <div className='w-2/5'>
                                              <div class="text-gray-500 text-sm font-semibold">Feed Name</div>
                                              <div class="text-sm text-gray-900 dark:text-gray-100 text-wrap">Modibodi EU CH</div>
                                            </div>
                                            <div  className='w-1/5'>
                                              <div class="text-gray-500 text-sm font-semibold">Country</div>
                                              <div class="text-sm text-gray-900 dark:text-gray-100">CH</div>
                                            </div>
                                            <div className='w-1/5'>
                                              <span className="ml-6 flex h-7 items-center float-right">
                                                <CheckboxGroup>
                                                  <CheckboxField>
                                                    <Checkbox name="discoverability" value="show_on_events_page" checked={selectedIds.includes("mb_ch")} onChange={() => handleCheckboxChange("mb_ch")} />
                                                  </CheckboxField>
                                                </CheckboxGroup>
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                      <li key="1" className="col-span-1 flex dark:shadow-none bg-stone-200 dark:bg-gray-900">
                        <div class="w-1/4 m-auto">
                          <div className={classNames("",'flex items-center justify-center rounded-l-md text-sm/6 font-medium m-4',)} >
                            Modibodi AU (6678943)
                          </div>
                        </div>
                        <div className="flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b border-gray-200 bg-white dark:border-white/10 dark:bg-gray-800/50 w-full">
                          <div className="flex truncate px-4 py-2 text-sm/6 w-full">
                            <div className='w-1/5'>
                              <div class="text-gray-500 text-sm font-semibold">Feed ID</div>
                              <div class="text-sm text-gray-900 dark:text-gray-100">765411234</div>
                            </div>
                            <div className='w-2/5'>
                              <div class="text-gray-500 text-sm font-semibold">Feed Name</div>
                              <div class="text-sm text-gray-900 dark:text-gray-100">Modibodi AU Feed</div>
                            </div>
                            <div  className='w-1/5'>
                              <div class="text-gray-500 text-sm font-semibold">Country</div>
                              <div class="text-sm text-gray-900 dark:text-gray-100">AU</div>
                            </div>
                            <div className='w-1/5'>
                              <span className="ml-6 flex h-7 items-center float-right">
                                <CheckboxGroup>
                                  <CheckboxField>
                                    <Checkbox name="discoverability" value="show_on_events_page" checked={selectedIds.includes("mb_au")} onChange={() => handleCheckboxChange("mb_au")} />
                                  </CheckboxField>
                                </CheckboxGroup>
                              </span>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>

              <li key="5" className="col-span-1 flex rounded-md shadow-md dark:shadow-none bg-stone-600 dark:bg-gray-900">
                <div class="w-1/5 text-white rounded-l-md m-auto">
                  <div className={classNames("",'text-center rounded-l-md text-sm/6 font-medium m-4',)} >
                    <p>RS Components</p>
                    <p>(6524409)</p>
                  </div>
                </div>
                <div className="flex flex-1 items-center justify-between truncate  bg-white dark:bg-gray-800/50">
                  <div className="flex-1 truncate text-sm/6">
                    <ul role="list" className="grid grid-cols-1 gap-2 sm:grid-cols-1 sm:gap-2 lg:grid-cols-1">
                      <li key="1" className="col-span-1 flex dark:shadow-none bg-stone-200 dark:bg-gray-900">
                        <div class="w-1/4 m-auto">
                          <div className={classNames("",'flex items-center justify-center rounded-l-md text-sm/6 font-medium m-4',)} >
                            RS Components (8416022)
                          </div>
                        </div>
                        <div className="flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b border-gray-200 bg-white dark:border-white/10 dark:bg-gray-800/50 w-full">
                          <div className="text-sm/6 w-full">
                            <ul role="list" className="grid grid-cols-1 gap-2 sm:grid-cols-1 sm:gap-2 lg:grid-cols-1">
                              <li key="1" className="col-span-1 flex rounded-md shadow-xs dark:shadow-none">
                                <div className="flex flex-1 items-center justify-between truncate  rounded-r-md border-t border-r border-b border-gray-200 bg-white dark:border-white/10 dark:bg-gray-800/50 w-full">
                                  <div className="flex truncate px-4 py-2 text-sm/6 w-full">
                                    <div className='w-1/5'>
                                      <div class="text-gray-500 text-sm font-semibold">Feed ID</div>
                                      <div class="text-sm text-gray-900 dark:text-gray-100">127757672</div>
                                    </div>
                                    <div className='w-2/5'>
                                      <div class="text-gray-500 text-sm font-semibold">Feed Name</div>
                                      <div class="text-sm text-gray-900 dark:text-gray-100">RS UK GB</div>
                                    </div>
                                    <div  className='w-1/5'>
                                      <div class="text-gray-500 text-sm font-semibold">Country</div>
                                      <div class="text-sm text-gray-900 dark:text-gray-100">GB</div>
                                    </div>
                                    <div className='w-1/5'>
                                      <span className="ml-6 flex h-7 items-center float-right">
                                        <CheckboxGroup>
                                          <CheckboxField>
                                            <Checkbox name="discoverability" value="show_on_events_page" checked={selectedIds.includes("rs_gb")} onChange={() => handleCheckboxChange("rs_gb")} />
                                          </CheckboxField>
                                        </CheckboxGroup>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li key="1" className="col-span-1 flex rounded-md shadow-xs dark:shadow-none">
                                <div className="flex flex-1 items-center justify-between truncate  rounded-r-md border-t border-r border-b border-gray-200 bg-white dark:border-white/10 dark:bg-gray-800/50 w-full">
                                  <div className="flex truncate px-4 py-2 text-sm/6 w-full">
                                    <div className='w-1/5'>
                                      <div class="text-gray-500 text-sm font-semibold">Feed ID</div>
                                      <div class="text-sm text-gray-900 dark:text-gray-100">165472229</div>
                                    </div>
                                    <div className='w-2/5'>
                                      <div class="text-gray-500 text-sm font-semibold">Feed Name</div>
                                      <div class="text-sm text-gray-900 dark:text-gray-100 text-wrap">RS Spain ES</div>
                                    </div>
                                    <div  className='w-1/5'>
                                      <div class="text-gray-500 text-sm font-semibold">Country</div>
                                      <div class="text-sm text-gray-900 dark:text-gray-100">ES</div>
                                    </div>
                                    <div className='w-1/5'>
                                      <span className="ml-6 flex h-7 items-center float-right">
                                        <CheckboxGroup>
                                          <CheckboxField>
                                            <Checkbox name="discoverability" value="show_on_events_page" checked={selectedIds.includes("rs_es")} onChange={() => handleCheckboxChange("rs_es")} />
                                          </CheckboxField>
                                        </CheckboxGroup>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li key="1" className="col-span-1 flex rounded-md shadow-xs dark:shadow-none">
                                <div className="flex flex-1 items-center justify-between truncate  rounded-r-md border-t border-r border-b border-gray-200 bg-white dark:border-white/10 dark:bg-gray-800/50 w-full">
                                  <div className="flex truncate px-4 py-2 text-sm/6 w-full">
                                    <div className='w-1/5'>
                                      <div class="text-gray-500 text-sm font-semibold">Feed ID</div>
                                      <div class="text-sm text-gray-900 dark:text-gray-100">376763169</div>
                                    </div>
                                    <div className='w-2/5'>
                                      <div class="text-gray-500 text-sm font-semibold">Feed Name</div>
                                      <div class="text-sm text-gray-900 dark:text-gray-100 text-wrap">RS Singapore SG</div>
                                    </div>
                                    <div  className='w-1/5'>
                                      <div class="text-gray-500 text-sm font-semibold">Country</div>
                                      <div class="text-sm text-gray-900 dark:text-gray-100">SG</div>
                                    </div>
                                    <div className='w-1/5'>
                                      <span className="ml-6 flex h-7 items-center float-right">
                                        <CheckboxGroup>
                                          <CheckboxField>
                                            <Checkbox name="discoverability" value="show_on_events_page" checked={selectedIds.includes("rs_sg")} onChange={() => handleCheckboxChange("rs_sg")} />
                                          </CheckboxField>
                                        </CheckboxGroup>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li key="1" className="col-span-1 flex rounded-md shadow-xs dark:shadow-none">
                                <div className="flex flex-1 items-center justify-between truncate  rounded-r-md border-t border-r border-b border-gray-200 bg-white dark:border-white/10 dark:bg-gray-800/50 w-full">
                                  <div className="flex truncate px-4 py-2 text-sm/6 w-full">
                                    <div className='w-1/5'>
                                      <div class="text-gray-500 text-sm font-semibold">Feed ID</div>
                                      <div class="text-sm text-gray-900 dark:text-gray-100">266791047</div>
                                    </div>
                                    <div className='w-2/5'>
                                      <div class="text-gray-500 text-sm font-semibold">Feed Name</div>
                                      <div class="text-sm text-gray-900 dark:text-gray-100 text-wrap">RS Components Indonesia EN ID</div>
                                    </div>
                                    <div  className='w-1/5'>
                                      <div class="text-gray-500 text-sm font-semibold">Country</div>
                                      <div class="text-sm text-gray-900 dark:text-gray-100">ID</div>
                                    </div>
                                    <div className='w-1/5'>
                                      <span className="ml-6 flex h-7 items-center float-right">
                                        <CheckboxGroup>
                                          <CheckboxField>
                                            <Checkbox name="discoverability" value="show_on_events_page" checked={selectedIds.includes("rs_id")} onChange={() => handleCheckboxChange("rs_id")} />
                                          </CheckboxField>
                                        </CheckboxGroup>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li key="1" className="col-span-1 flex rounded-md shadow-xs dark:shadow-none">
                                <div className="flex flex-1 items-center justify-between truncate  rounded-r-md border-t border-r border-b border-gray-200 bg-white dark:border-white/10 dark:bg-gray-800/50 w-full">
                                  <div className="flex truncate px-4 py-2 text-sm/6 w-full">
                                    <div className='w-1/5'>
                                      <div class="text-gray-500 text-sm font-semibold">Feed ID</div>
                                      <div class="text-sm text-gray-900 dark:text-gray-100">110900547</div>
                                    </div>
                                    <div className='w-2/5'>
                                      <div class="text-gray-500 text-sm font-semibold">Feed Name</div>
                                      <div class="text-sm text-gray-900 dark:text-gray-100 text-wrap">RS Denmark DK</div>
                                    </div>
                                    <div  className='w-1/5'>
                                      <div class="text-gray-500 text-sm font-semibold">Country</div>
                                      <div class="text-sm text-gray-900 dark:text-gray-100">DK</div>
                                    </div>
                                    <div className='w-1/5'>
                                      <span className="ml-6 flex h-7 items-center float-right">
                                        <CheckboxGroup>
                                          <CheckboxField>
                                            <Checkbox name="discoverability" value="show_on_events_page" checked={selectedIds.includes("rs_dk")} onChange={() => handleCheckboxChange("rs_dk")} />
                                          </CheckboxField>
                                        </CheckboxGroup>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>

            </ul>
          </div>


          <div className="mt-6 flex space-x-4 justify-center">
			      <Button class="w-40 cursor-pointer" onClick={handleAddCompany} >
		          <PlusIcon />
		          Add Company
		        </Button>
			      <Button color="white" class="w-40 cursor-pointer">Clear</Button>		  
		      </div>
    <Dialog open={isOpenConfirm} onClose={setIsOpenConfirm} size="xl">
        <DialogTitle>Confirm</DialogTitle>
        <DialogDescription>Are you sure, you want to add the below company?</DialogDescription>
        <DialogBody className="text-sm/6 text-zinc-900 dark:text-white">
			<Table>
			  <TableHead>
				<TableRow className="text-zinc-950 dark:text-white">
				  <TableHeader>Account Name</TableHeader>
          <TableHeader>Feed Name</TableHeader>
				  <TableHeader>Country</TableHeader>
				  <TableHeader>Products</TableHeader>
				</TableRow>
			  </TableHead>
			  <TableBody>
          <TableRow key="1">
            <TableCell className="text-zinc-500">Dryrobe DE</TableCell>
            <TableCell className="text-zinc-500">DryRobe DE | FeedSpark</TableCell>
            <TableCell className="text-zinc-500">DE</TableCell>					
            <TableCell className="text-zinc-500">4579</TableCell>					
          </TableRow>
          <TableRow key="2">
            <TableCell className="text-zinc-500">Hobbs</TableCell>
            <TableCell className="text-zinc-500">Hobbs GB Feed</TableCell>
            <TableCell className="text-zinc-500">GB</TableCell>					
            <TableCell className="text-zinc-500">12690</TableCell>					
          </TableRow>
			  </TableBody>   
			</Table>    
        </DialogBody>
        <DialogActions>
          <Button plain onClick={() => setIsOpenConfirm(false)}>Cancel</Button>
          <Button onClick={() => {setIsOpenConfirm(false);setConfirmed(true);}}>Yes Proceed</Button>
        </DialogActions>
      </Dialog>
       </SidebarLayoutNew>
    </Fragment>
  );
}